// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 524) return "app-v2-6bad8f82.css";
	// return url for filenames based on template
	return "" + ({"188":"playground","795":"canvas"}[chunkId] || chunkId) + "-v2-" + {"188":"32e24e9f","531":"846a8e63","789":"846a8e63","795":"32e24e9f"}[chunkId] + ".chunk.css";
};